import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ComponentFactoryResolver, } from '@angular/core';
import { NotificationMobilePopupComponent } from '../components/notification-mobile-popup/notification-mobile-popup.component';
import { NotificationPopupComponent } from '../components/notification-popup/notification-popup.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/layout";
export class NotificationService {
    constructor(componentFactoryResolver, breakpointObserver) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.breakpointObserver = breakpointObserver;
        this.queue = [];
        this.isMobile = false;
        this.breakpointObserver
            .observe(['(max-width: 767px)'])
            .subscribe((state) => {
            this.isMobile = state.matches;
        });
    }
    setNotificationContainer(ref) {
        this.notificationContainer = ref;
        if (this.queue.length > 0) {
            this.queue.forEach(notification => {
                this.showNotification(notification);
            });
        }
    }
    showNotification(text, icon = '') {
        if (!this.notificationContainer) {
            this.queue.push(text);
            return;
        }
        if (this.isMobile) {
            const componentFactoryMobile = this.componentFactoryResolver.resolveComponentFactory(NotificationMobilePopupComponent);
            const componentRefMobile = this.notificationContainer.viewContainer.createComponent(componentFactoryMobile);
            componentRefMobile.instance.notificationText = text;
            componentRefMobile.instance.componentRef = componentRefMobile;
        }
        else {
            const componentFactory = this.componentFactoryResolver.resolveComponentFactory(NotificationPopupComponent);
            const componentRef = this.notificationContainer.viewContainer.createComponent(componentFactory);
            componentRef.instance.notificationText = text;
            componentRef.instance.componentRef = componentRef;
        }
    }
}
NotificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i1.BreakpointObserver)); }, token: NotificationService, providedIn: "root" });
